import './badge.scss';

type BadgeProps = {
  value?: string;
  className?: string;
};

export function Badge({ value, className }: BadgeProps) {
  return (
    <div className={`badge${className ? ` ${className}` : ''}`}>{value}</div>
  );
}
